(() => {
  const init = (root) => {
    if (!root || root.dataset.s27Initialised === 'true') return;
    root.dataset.s27Initialised = 'true';

    const filterPanel = root.querySelector('[data-s27-filters]');
    const openButton = root.querySelector('[data-s27-filter-open]');
    const closeButton = root.querySelector('[data-s27-filter-close]');

    const close = () => {
      if (!filterPanel) return;
      filterPanel.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    };

    const open = () => {
      if (!filterPanel) return;
      filterPanel.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    };

    openButton?.addEventListener('click', open);
    closeButton?.addEventListener('click', close);

    root.querySelectorAll('[data-s27-quick-add]').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        if (!button || button.disabled) return;
        const original = button.textContent;
        button.disabled = true;
        button.textContent = 'Adding…';
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(form.elements.id.value), quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Add to basket failed');
          button.textContent = 'Added';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(() => { button.textContent = original; button.disabled = false; }, 1300);
        } catch (error) {
          button.textContent = 'View product';
          window.location.href = form.dataset.productUrl;
        }
      });
    });
  };

  document.querySelectorAll('[data-s27-collection]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-s27-collection]')));
})();
